export const DEFAULT_COMPARISON_MIN_SELECTION = 2;
export const DEFAULT_COMPARISON_MAX_SELECTION = 3;

interface ComparisonBoundsInput {
  minItems?: number;
  maxItems?: number;
}

interface ComparisonBounds {
  minItems: number;
  maxItems: number;
}

export function normalizeComparisonBounds({
  minItems,
  maxItems,
}: ComparisonBoundsInput = {}): ComparisonBounds {
  const normalizedMinItems = Math.max(
    1,
    minItems ?? DEFAULT_COMPARISON_MIN_SELECTION,
  );
  const normalizedMaxItems = Math.max(
    maxItems ?? DEFAULT_COMPARISON_MAX_SELECTION,
    normalizedMinItems,
  );

  return {
    minItems: normalizedMinItems,
    maxItems: normalizedMaxItems,
  };
}
